import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/Counter/components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'counter',
    name: 'counter',
    component: Index,
    title: 'counter',
    redirect: { name: 'counter-list' },
    children: [
      {
        path: 'list',
        name: 'counter-list',
        component: List,
      },
      
    ],
  },
]
